export const settings = {
  //#region API URL
  // Localhost
  // checkAuthApiUrl: "https://localhost:44343/Api/AuthCheck",
  // apiUrl: "https://localhost:44343/Api/Proxy/",

  // UAT
  // checkAuthApiUrl: "https://uatgateway.teamstar.com.my/Api/AuthCheck",
  // apiUrl: "https://uatgateway.teamstar.com.my/Api/Proxy/",

  // Prod
  checkAuthApiUrl: "https://gateway.teamstar.com.my/Api/AuthCheck",
  apiUrl: "https://gateway.teamstar.com.my/Api/Proxy/",
  //#endregion

  // To Encrypt the data that will be sent to the server
  encryptKey: "V5AUALHfPunfJLKA",

  //#region Image URL
  // UAT
  // staticSEOJsonUrl: "https://uat.teamstar.com.my/files/seo/seo-static.json",

  staticSEOJsonUrl: "https://teamstar.com.my/files/seo/seo-static.json",

  // homePageCarouselImageFolder:
  //   "https://uat.teamstar.com.my/images/homepagecarousel/",
  // productImageFolder: "https://uat.teamstar.com.my/images/products/",
  // productMoreInfoImageFolder:
  //   "https://uat.teamstar.com.my/images/products/moreinfo/",
  // promoImageFolder: "https://uat.teamstar.com.my/images/promo/",
  // categoryImageFolder: "https://uat.teamstar.com.my/images/category/",
  // catalogsImageFolder: "https://uat.teamstar.com.my/images/catalogs/",

  // Prod
  homePageCarouselImageFolder: "/images/homepagecarousel/",
  productImageFolder: "https://teamstar.com.my/images/products/",
  productMoreInfoImageFolder:
    "https://teamstar.com.my/images/products/moreinfo/",
  promoImageFolder: "https://teamstar.com.my/images/promo/",
  categoryImageFolder: "https://teamstar.com.my/images/category/",
  catalogsImageFolder: "https://teamstar.com.my/images/catalogs/",
  //#endregion

  //#region Files URL
  // UAT
  // filesFolder: "https://uat.teamstar.com.my/files/",
  // catalogsFileFolder: "https://uat.teamstar.com.my/files/catalogs/",

  // Prod
  filesFolder: "https://teamstar.com.my/files/",
  catalogsFileFolder: "https://teamstar.com.my/files/catalogs/",
  //#endregion

  //#region API URL
  user: {
    register: "User/Register",
    requestOTP: "User/RequestOTP",
    login: "User/Login",
    logout: "User/Logout",
    getProfileDetails: "User/GetProfileDetails",
    requestQuotation: "User/RequestQuotation",
  },

  jwt: {
    generateJWTToken: "Jwt/GenerateJWTToken",
  },

  publicData: {
    getProducts: "PublicData/GetProducts",
    getProductById: "PublicData/GetProductById",
    getRandomProducts: "PublicData/GetRandomProducts",
    checkProductAvailability: "PublicData/CheckProductAvailability",
    requestQuotation: "PublicData/RequestQuotation",

    getFeaturedCategory: "PublicData/GetFeaturedCategory",
    getCategories: "PublicData/GetCategories",
    getSubCategories: "PublicData/GetSubCategories",
    getCombinedCategories: "PublicData/GetCombinedCategories",

    newsletterSub: "PublicData/NewsletterSub",

    contactUs: "PublicData/ContactUs",

    getPromotions: "PublicData/GetPromotions",
    getPromotionDetails: "PublicData/GetPromotionDetails",

    getCatalogs: "PublicData/GetCatalogs",
  },
  //#endregion
};
